module.exports = __webpack_public_path__ + "img/arrow-top-left.c6a70d6c.svg";